import createReactContext from '@ant-design/create-react-context';
export var TreeContext = createReactContext(null);